import ProjectResponsibilities from './ProjectResponsibilities';
export default ProjectResponsibilities;